const SIGN_SERVICE_ID = 'signService';
export { SIGN_SERVICE_ID };
